<template>
  <el-row>
    <el-col>
      <el-card :body-style="{ padding: '10px' }">
          <img v-if="special.src" @click="skip()" v-lazy="special.src" class="image" alt="待展示" style="cursor: pointer"/>
          <div style="padding: 10px;">
            <div @click="skip()" style="cursor: pointer">{{special.title}}</div>
          </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    special: {
      type: Object,
    },
  },
  methods: {
      skip(){
        if(this.special.number != null){
          if(this.special.number.substring(0,2) == 'WZ' || this.special.number.substring(0,2) == 'SP'){
              this.$router.push({ path: '/index/article',query:{id:this.special.number}})
              if(this.$route.path == '/index/article'){
                  this.$store.commit("setartrcleNumber",this.special.number);
              }
          }else if(this.special.number.substring(0,2) == 'ZT'){
              this.$router.push({ path: '/special',query:{id:this.special.number}})
          }else {
              window.open(this.special.number);
          }
      }else{
        this.$message({
          message: '该文章已下架',
          type: 'warning'
        });
      }
      }
  },
  mounted(){
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  width: 320px;
  padding: 0 0 0 20px;
  box-sizing: border-box;
  img {
    width: 100%;
    height: 170px;
  }
}
/deep/.el-col {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.01), 0 0 3px rgba(0, 0, 0, 0.04);
  margin: 0 0 20px 0;
}
// @media (max-width: 1500px){
//  /deep/.el-row{
//    width: 300px;
//    height: 300px;
//  }
// }
</style>